import { Link } from 'greenback-shared/components';
import { paths } from '@/config/paths';

const NotFoundRoute = () => {
  return (
    <div className="mt-52 flex flex-col items-center font-semibold">
      <h1>404 - Not Found</h1>
      <p>La pagina che stai cercando non esiste.</p>
      <Link to={paths.login.getHref()} replace>
        Torna alla homepage
      </Link>
    </div>
  );
};

export default NotFoundRoute;
